import { OptionalUnits } from 'pages/K8Teach/constants'

function transformLessons(contentLessons, lmsLessons = []) {
  return contentLessons.map((contentLesson, index) => {
    const transformed = toInstanceLesson(contentLesson)
    const lmsLesson = lmsLessons[index]

    return {
      ...transformed,
      ...lmsLesson,
    }
  })
}

function isChoice(contentfulLesson) {
  return contentfulLesson?.lessonType === 'ChoiceCurriculum'
}

function collapseChoice(contentfulLesson) {
  if (!isChoice(contentfulLesson)) return {}
  return {
    choices: [
      toInstanceLesson(contentfulLesson.item1Lesson),
      toInstanceLesson(contentfulLesson.item2Lesson),
    ],
  }
}

function toInstanceLesson(contentfulLesson) {
  return {
    ...collapseChoice(contentfulLesson),
    attempted: 'preview',
    doneAt: null,
    is_done: null,
    progress: null,
    score: null,
    time: 'P0D',
    updatedAt: null,
  }
}

function getUnitId(route) {
  return route.split('/').pop()
}

const resettingIndexUnitIds = [OptionalUnits.BullyingHarassmentUnit.slug]

function getTabSummaries(contentUnit) {
  return Array.isArray(contentUnit?.courseContent?.tabSummaries)
    ? contentUnit.courseContent.tabSummaries
    : []
}

function getLessonStartingIndex(contentUnit, currentUnitId) {
  const tabSummaries = getTabSummaries(contentUnit)
  if (tabSummaries.length === 0) {
    return 1
  }

  const lessonsIndexesMap = tabSummaries.reduce((currentMap, unit, index) => {
    const tabUnitId = getUnitId(unit.route)

    if (index === 0 || resettingIndexUnitIds.includes(tabUnitId)) {
      currentMap[tabUnitId] = 1
      return currentMap
    } else {
      const prevUnitId = tabSummaries[index - 1].route.split('/').pop()
      currentMap[tabUnitId] =
        currentMap[prevUnitId] + tabSummaries[index - 1].lessonCount
    }
    return currentMap
  }, {})
  return lessonsIndexesMap[currentUnitId] ?? 1
}

/**
 * After client-side unit tab switches, leftover lessons from the previous unit
 * can remain prepended on the current unit payload. Keep only the current
 * tab's lessons when tabSummaries tells us how many belong here.
 */
export function resolveCurrentUnitLessons({ contentUnit, currentUnitId }) {
  const contentLessons = Array.isArray(contentUnit?.lessons)
    ? contentUnit.lessons
    : []
  const unitTabs = getTabSummaries(contentUnit)
  const currentTab = unitTabs.find(
    unit => getUnitId(unit.route) === currentUnitId,
  )
  const expectedCount = currentTab?.lessonCount

  if (
    typeof expectedCount !== 'number' ||
    expectedCount <= 0 ||
    contentLessons.length <= expectedCount
  ) {
    return contentLessons
  }

  return contentLessons.slice(-expectedCount)
}

export function getData({ contentUnit, currentUnitId, lmsUnit }) {
  let advisoryActivities = new Set()
  const unitTabs = getTabSummaries(contentUnit)

  const { unitVideo, additionalResources } = contentUnit
  if (additionalResources) {
    additionalResources.forEach(additionalResource => {
      advisoryActivities.add(additionalResource.advisoryActivityType)
    })
  }

  const found = unitTabs.find(unit => getUnitId(unit.route) === currentUnitId)
  const unitName = found?.displayTitle || ''
  const contentLessons = resolveCurrentUnitLessons({
    contentUnit,
    currentUnitId,
  })

  const lmsLessons = transformLessons(contentLessons, (lmsUnit ?? {}).lessons)
  const lessonStartingIndex = getLessonStartingIndex(contentUnit, currentUnitId)
  return {
    advisoryActivities,
    contentLessons,
    unitVideo,
    lessonStartingIndex,
    lmsLessons,
    unitName,
    unitTabs,
  }
}

export const resolveLessonSummaries = ({
  isLessonPage,
  linkSummaries,
  unit,
}) => {
  if (!isLessonPage) return []

  if (Array.isArray(linkSummaries) && linkSummaries.length > 0) {
    return linkSummaries
  }

  if (Array.isArray(unit?.linkSummaries)) return unit.linkSummaries
  if (Array.isArray(unit?.linkSummariesCollection)) {
    return unit.linkSummariesCollection
  }

  return []
}
